import { Commande } from '@/model/commande/commande';
import { CommandeSAS } from '@/model/commande/sas/commande-sas';
import { ConfirmationCommande } from '@/model/confirmation-commande';
import Axios from 'axios';
import { JsonTsMapper } from 'json-ts-mapper';
import { ApiUtils } from './api-utils';

export class CommandeApi {
  static creerCommande (data: Commande): Promise<ConfirmationCommande> {
    return ApiUtils.responseParser(Axios.post('/web/v1/commande', JsonTsMapper.serialize(data)), ConfirmationCommande);
  }

  static valoriserCommande (data: Commande): Promise<Commande> {
    return ApiUtils.responseParser(Axios.patch('/web/v1/valoriser-commande', JsonTsMapper.serialize(data)), Commande);
  }

  static getHistoriqueCommandes (numTiers: string): Promise<CommandeSAS[]> {
    return ApiUtils.responseParser(Axios.get(`/web/v1/commande/${numTiers}`), [CommandeSAS]);
  }
}
